<template>
  <div v-loading.fullscreen.lock="isLoading">
    <el-card>
      <div slot="header">
        <!-- <el-button style="padding: 3px 0" type="text" @click="back">
          <i class="el-icon-arrow-left"></i>
        </el-button> -->
        <el-row style="line-height: 40px">
          <el-col :span="6">
            <div style="font-size: 16px; font-weight: bold">
              <el-button style="padding: 3px 0" type="text" @click="back">
                <i class="el-icon-arrow-left"></i>
                返回
              </el-button>
              <el-divider direction="vertical"></el-divider>
              <span> 加分考範圍 </span>
            </div>
          </el-col>
          <el-col :span="6" :offset="12">
            <!-- <div id="lifeClass_btAdd"> -->
            <el-button
              id="test_lifeClass_btAdd"
              style="float: right; margin-right: 10px"
              type="primary"
              @click="gotoAddPointsApply"
              :disabled="mothballType"
              >報考</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div>
        <el-row style="margin-left: 20px; font-size: 16px; line-height: 10px">
          <el-col :span="5">
            <el-row>
              <span
                style="font-size: 30px; font-weight: bold; line-height: 20px"
                >{{ sgName }}</span
              >
            </el-row>
            <br />
            <br />
            <el-row>
              <span
                style="font-weight: bold; font-size: 20px; line-height: 20px"
                >{{ id }}</span
              >
              <el-tag
                v-if="mothballType"
                type="danger"
                effect="plain"
                style="margin-left: 20px"
                >已封存</el-tag
              >
              <el-tag
                v-else
                type="info"
                effect="plain"
                style="margin-left: 20px"
                >未封存</el-tag
              >
            </el-row>
          </el-col>

          <el-col :span="19">
            <el-col :span="6">
              <div
                style="
                  border-right: 2px #8f8f8f solid;
                  border-left: 2px #8f8f8f solid;
                  min-height: 50px;
                "
              >
                <div style="margin-left: 20px">
                  <el-row>
                    <span>學年度</span>
                  </el-row>
                  <br />
                  <br />
                  <el-row>
                    <span
                      style="
                        font-size: 20px;
                        font-weight: bold;
                        line-height: 20px;
                      "
                      >{{ year }}</span
                    >
                  </el-row>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div style="border-right: 2px #8f8f8f solid; min-height: 50px">
                <div style="margin-left: 20px">
                  <el-row>
                    <span>學制班</span>
                  </el-row>
                  <br />
                  <br />
                  <el-row>
                    <span
                      style="
                        font-size: 20px;
                        font-weight: bold;
                        line-height: 20px;
                      "
                      >{{ syTitel }}</span
                    >
                  </el-row>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div style="border-right: 2px #8f8f8f solid; min-height: 50px">
                <div style="margin-left: 20px; color: #5178aa">
                  <el-row>
                    <span>背書總字數</span>
                  </el-row>
                  <br />
                  <br />
                  <el-row>
                    <span
                      style="
                        font-size: 20px;
                        font-weight: bold;
                        line-height: 20px;
                      "
                      >{{ count }}</span
                    >
                  </el-row>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div style="margin-left: 20px; color: #dda450">
                <el-row>
                  <span>背書總得分</span>
                </el-row>
                <br />
                <br />
                <el-row>
                  <span
                    style="
                      font-size: 20px;
                      font-weight: bold;
                      line-height: 20px;
                    "
                    >{{ points }}</span
                  >
                </el-row>
              </div>
            </el-col>
          </el-col>
        </el-row>
      </div>
      <br />
      <el-row
        style="
          margin-left: 40px;
          margin-right: 20px;
          font-size: 16px;
          font-weight: bold;
          line-height: 5px;
        "
      >
        <el-col :span="6">
          <span>已報考範圍</span>
        </el-col>
        <el-col :span="2" :offset="16">
          <el-button
            style="margin: -20px"
            type="danger"
            @click="deleteAll()"
            :disabled="mothballType"
            >批次取消報考</el-button
          >
        </el-col>
      </el-row>

      <el-col :span="6">
        <el-divider></el-divider>
        <el-input
          :prefix-icon="qString == '' ? 'el-icon-search' : ''"
          placeholder="請輸入 分格編號、書目"
          v-model="qString"
          @keyup.enter.native="query"
        ></el-input>
      </el-col>
      <el-col :span="6" :offset="12">
        <br />
        <el-row style="margin-bottom: 10px">
          <span style="font-weight: bold">單筆新增報考及通過 </span>
        </el-row>
        <el-row>
          <el-input
            :prefix-icon="addOne == '' ? 'el-icon-search' : ''"
            placeholder="請輸入 完整分格編號"
            v-model="addOne"
            @keyup.enter.native="saveOne"
            :disabled="mothballType"
          ></el-input>
        </el-row>
      </el-col>

      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        @selection-change="isCheckRow"
      >
        <el-table-column type="selection" width="50"> </el-table-column>

        <el-table-column
          prop="id"
          label="分格編號"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="book"
          label="書目"
          width="100"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="chapter"
          label="品項"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="bookRange"
          label="分格範圍"
          width="200"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="count"
          label="字數"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="bookType"
          label="類別"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="points"
          label="得分"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="frequency"
          label="歷年連續通過次數"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="pass"
          fixed="right"
          label="通過與否"
          width="100"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.pass" style="color: #7ebe50">通過</div>
            <div v-else style="color: #e57470">未通過</div>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
          width="100"
          header-align="center"
          align="center"
          v-if="!mothballType"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.pass"
              type="danger"
              size="small"
              @click="passChange(scope.row)"
              >未通過</el-button
            >
            <el-button
              v-else
              type="success"
              size="small"
              @click="passChange(scope.row)"
              >通過</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import API from "../../api";
import Utils from "../../utils";
import { InformType } from "@/utils/InformType";

export default {
  name: "addPoints",

  data() {
    return {
      isLoading: false,
      disLoading: false,
      tableData: [],

      qString: "",
      id: "",
      sgName: "",
      points: "",
      count: "",
      syTitel: "",
      year: "",
      addOne: "",
      mothballType: false,

      checkRow: [],
    };
  },

  created() {
    this.getMothballType();
    this.query();
    this.getPerson();
  },

  methods: {
    query() {
      console.log("讀取");
      this.isLoading = true;
      API.addPointsApply
        .findAll(this.$route.query.id, this.$route.query.pid, this.qString)
        .then((res) => {
          this.tableData = res.data.addPoints;
          this.count = res.data.count;
          this.points = res.data.points;
          console.log(res.data);
          this.isLoading = false;
        });
    },

    saveOne() {
      console.log("報考");
      API.addPointsApply
        .saveAll(this.$route.query.id, this.$route.query.pid, [this.addOne])
        .then(() => {
          Utils.Message.send("報考成功!", InformType.SUCCESS);
          this.addOne = "";
          this.isLoading = false;
          this.query();
        })
        .catch(() => {
          Utils.Message.send("查無分格編號", InformType.ERROR);
        });
    },

    deleteAll() {
      if (this.checkRow.length < 1) {
        Utils.Message.send("尚未勾選取消報考資料!", InformType.ERROR);
        return;
      }
      this.isLoading = true;

      API.addPointsApply
        .deleteAll(this.$route.query.id, this.$route.query.pid, this.checkRow)
        .then(() => {
          Utils.Message.send("取消報考成功!", InformType.SUCCESS);
          this.isLoading = false;
          this.query();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    getMothballType() {
      API.studyYear.mothballType(this.$route.query.id).then((res) => {
        this.mothballType = res.data;
      });
    },

    getPerson() {
      console.log("讀取人員");
      this.isLoading = true;
      API.person
        .showIdSgname(this.$route.query.id, this.$route.query.pid)
        .then((res) => {
          this.id = res.data.id;
          this.sgName = res.data.sgName;
          this.year = res.data.year;
          this.syTitel = res.data.sy;
          console.log(res.data);
          this.isLoading = false;
        });
    },

    isCheckRow(val) {
      this.checkRow = val.map((item) => {
        return item.id;
      });
      console.log("選中row: ", this.checkRow);
    },

    gotoAddPointsApply() {
      this.$router.push({
        path: `/addPointsApply?id=${this.$route.query.id}&pid=${this.$route.query.pid}`,
      });
    },

    back() {
      if (this.$route.query.to == "personEducation")
        this.$router.push({
          path: `/personEducation?id=${this.$route.query.pid}`,
        });
      else
        this.$router.push({ path: `/recitePoints?id=${this.$route.query.id}` });
    },

    passChange(row) {
      API.addPointsApply
        .passChange(row.applyId)
        .then((res) => {
          Utils.Message.send("通過狀態修改成功!", InformType.SUCCESS);
          row.pass = res.data.addPoints.pass;
          row.points = res.data.addPoints.points;
          this.points = res.data.points;
          this.count = res.data.count;
        })
        .catch(() => {
          Utils.Message.send("通過狀態修改失敗!", InformType.ERROR);
        });
    },
  },
};
</script>

<style>
.darkblue {
  background-color: #527bae;
  color: #ffffff;
}
</style>